import { ErrorResponse } from "../responses/ErrorResponse";

export class UnprocessableEntityError extends ErrorResponse {
    public message: string;
    public errors: { [k: string]: string[] }
}



// WEBPACK FOOTER //
// ./src/providers/api/errors/UnprocessableEntityError.ts